var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import moment from "moment";
import { ArtifactModal } from "./artifacts/ArtifactModal";
import { DynamicTable } from "@atlassiansox/microscopekit";
import styled from "styled-components";
var DateTimeDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"], ["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"])));
var StyledContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\ntable > tbody > tr:nth-child(even) {\n  background: #f4f5f7;\n}\n"], ["\ntable > tbody > tr:nth-child(even) {\n  background: #f4f5f7;\n}\n"])));
var ReleaseTableView = /** @class */ (function (_super) {
    __extends(ReleaseTableView, _super);
    function ReleaseTableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isDateTime: false,
        };
        _this.renderCreatedBy = function (createdBy) {
            if (createdBy === "bamboo-sox-bot") {
                return React.createElement("p", null, "\"bamboo-sox-bot\"");
            }
            else if (createdBy === "customcloudformation") {
                return ""; // Return nothing, since this trigger is meaningless and shouldn't exist anymore
            }
            else if (createdBy.includes(":")) {
                return _this.renderCreatedByBuild(createdBy);
            }
            else if (createdBy === _this.props.id) {
                return React.createElement("p", null, "\"micros token\"");
            }
            else {
                // The last case should be a manual deploy. We can check this by hitting the endpoint for a 2xx
                // but it's probably not worth the extra traffic
                return React.createElement("a", { title: "Manually deployed by " + createdBy, href: "https://directory.prod.atl-paas.net/employees/" + createdBy }, createdBy);
            }
        };
        _this.renderCreatedByBuild = function (createdBy) {
            // Currently only deploy tokens include ':' in the createdBy field
            // so we can assume this is a build/deploy ID and we can render the bamboo/bbp url
            var buildId = createdBy.split(":");
            var issuer = buildId[0];
            var link;
            if (issuer === "bitbucket-pipelines") {
                link = _this.renderCreatedByBBP(createdBy);
            }
            else if (issuer.includes("spinnaker")) {
                link = _this.renderCreatedBySpinnaker(createdBy);
            }
            else {
                link = _this.renderCreatedByBamboo(createdBy);
            }
            return React.createElement("a", { title: createdBy, href: link }, issuer);
        };
        _this.renderCreatedByBBP = function (createdBy) {
            var buildId = createdBy.split(":");
            var _ = buildId[0], workspace = buildId[1], repo = buildId[2], pipeline = buildId[3];
            return "https://bitbucket.org/" + workspace + "/" + repo + "/addon/pipelines/home#!/results/" + pipeline;
        };
        _this.renderCreatedByBamboo = function (createdBy) {
            var buildId = createdBy.split(":");
            var issuer = buildId[0];
            if (buildId.length === 2) {
                // This case occurs when micros uses a build principal, instead of the build ID as the triggeredBy user
                // We do not know the build ID in this case, so we direct the user to the build instead
                return "https://" + issuer + ".internal.atlassian.com/browse/" + buildId[1];
            }
            // Here we need to differentiate between a build and deploy plan. The hack is to see if the principal
            // is part of the build plan name. If it is, then it's a build plan. Otherwise it's a deploy plan.
            var first = buildId[1], second = buildId[2];
            if (second.includes(first)) {
                return "https://" + issuer + ".internal.atlassian.com/browse/" + first + "-" + second;
            }
            else {
                // If it's a deploy plan, it's tricky to find the exact deploy, since the url needs a versionID but
                // slauth only gives us the deploymentResultId, so we best we can do here is point to the build plan
                return "https://" + issuer + ".internal.atlassian.com/browse/" + first;
            }
        };
        _this.renderCreatedBySpinnaker = function (createdBy) {
            var ids = createdBy.split(":");
            var issuer = ids[0], app = ids[1], _ = ids[2], execution = ids[3];
            var spinnakerRootUrl;
            switch (issuer) {
                // TODO: add these in when spinnaker uses different issuers to dev/root/stg
                /*
                case "spinnaker-dev":
                  spinnakerRootUrl = "https://spinnaker-dev.internal.shared-dev.us-west-2.kitt-inf.net"
                  break;
                case "spinnaker-root":
                  spinnakerRootUrl = "https://spinnaker-dev.internal.shared-dev.us-west-2.kitt-inf.net"
                  break;
                 */
                case "spinnaker-production":
                    spinnakerRootUrl = "https://spinnaker-prod.internal.shared-prod.us-east-1.kitt-inf.net";
                    break;
                default:
                    spinnakerRootUrl = "https://spinnaker-stg.internal.shared-stg.us-west-2.kitt-inf.net";
            }
            return spinnakerRootUrl + "/#/applications/" + app + "/executions/" + execution;
        };
        return _this;
    }
    ReleaseTableView.prototype.render = function () {
        var _this = this;
        var data = this.props.releaseGroups
            .map(function (rg) { return ({
            cells: [
                {
                    key: "",
                    content: React.createElement(DateTimeDiv, { onClick: function () { return _this.setState({ isDateTime: !_this.state.isDateTime }); } }, _this.state.isDateTime ? moment(rg.timestamp).format("YYYY-MM-DD HH:mm:ss") : moment(rg.timestamp).fromNow())
                },
                {
                    key: "",
                    content: React.createElement("span", null, rg.release.description)
                },
                {
                    key: "",
                    content: rg.release.artifacts
                        .filter(function (value) { return value != null; })
                        .map(function (artifact) {
                        return React.createElement(ArtifactModal, { id: _this.props.id, artifact: artifact, track: _this.props.track });
                    })
                        .reduce(function (prev, curr) { return React.createElement(React.Fragment, null,
                        prev,
                        curr); })
                },
                {
                    key: "",
                    content: React.createElement("span", null, _this.renderCreatedBy(rg.createdBy))
                },
            ]
        }); });
        return (React.createElement(StyledContainer, null,
            React.createElement(DynamicTable, { head: {
                    cells: [
                        { key: "date", content: "Date", width: 15 },
                        { key: "id", content: "Deployment ID", width: 15 },
                        { key: "artifacts", content: "Artifacts", width: 45 },
                        { key: "trigger", content: "Deployed By", width: 15 }
                    ]
                }, rows: data, isLoading: data.length === 0 })));
    };
    return ReleaseTableView;
}(React.Component));
export { ReleaseTableView };
var templateObject_1, templateObject_2;
